// Keep in sync with App\Enums\Emails\EmailFileType.
export enum EmailFileType {
  PDF = 'pdf',
  DOCX = 'docx',
  PPTX = 'pptx',
  XLSX = 'xlsx',
  JPEG = 'jpeg',
  PNG = 'png',
}

export const EMAIL_FILE_EXTENSIONS: readonly string[] = [
  ...Object.values(EmailFileType),
  'jpg',
];
